import React, { useState } from 'react';
import Select from 'react-select';


const Dropdown = ({ options, clearable, isMulti, customStyle, value, setValue, placeholder, label, errorFields, name }) => {

    let style = customStyle || {}
    return (<>
        <label style={{ display: 'flex', marginTop: '15px', fontSize: '15px', color: '#000', ...style, fontWeight: '700' }}>{label || ''}</label>
        <Select
            isMulti={!!isMulti}
            className={errorFields.includes(name) ? 'basic-single-error' : "basic-single"}
            classNamePrefix="select"
            isClearable={!!clearable}
            placeholder={placeholder || ''}
            value={value}
            options={options}
            onChange={setValue}
        />
    </>)
}

export default Dropdown